<template>
  <div class="upload" v-loading="aws_s3_loading" element-loading-background="rgba(0, 0, 0, 0.6)">
    <div class="upload_header">
        <img class="upload_t_logo" src="../../assets/img/Logo.png" alt="">
        <span class="upload_t_btn" @click="$router.push('/login')">{{$t('main.text4')}}</span>
    </div>
    <div class="upload_body">
        <el-form class="form_box" label-position="top" :model="form">

          <el-form-item>
            <div class="form_tit">
              {{$t('main.text216')}}
            </div>
          </el-form-item>

          <el-form-item>
            <div class="box_top_tit">{{$t('main.text217')}}</div>
            <el-upload
                class="upload-demo upload_box"
                drag
                :limit="10"
                action="#"
                ref="upload-file"
                :show-file-list="true"
                accept=".jpg,.jpeg,.png,.JPG,.JPEG,.pdf,.PDF"
                :http-request="ossUpload"
                :before-remove="beforeRemove"
                multiple>
                <img class="load_icon" src="../../assets/img/upload_icon.png" alt="">
                <div class="el-upload__text upload_text">
                    <div>{{$t('main.text88')}}</div>
                    <div><el-button class="upload_btn">{{$t('main.text89')}}</el-button></div>
                    <div v-if="company_profile.length<=0">{{$t('main.text261')}}</div>
                    <div v-else>{{$t('main.text90')}}</div>
                </div>
            </el-upload>
          </el-form-item>

        <div v-for="(item,index) of shareholder_info" :key="index">
          <el-form-item :label="`${$t('main.text218')} ${index+1}`">
            <el-input v-model="item.name" :placeholder="$t('main.text220')"></el-input>
          </el-form-item>

          <el-form-item>
            <div class="box_top_tit">{{$t('main.text218')}} {{index+1}} {{$t('main.text219')}} </div>
            <el-upload
                class="upload-demo upload_box"
                drag
                :limit="10"
                action="#"
                :show-file-list="show_child"
                :file-list="fileList"
                accept=".jpg,.jpeg,.png,.JPG,.JPEG,.pdf,.PDF"
                :http-request="ossUpload_assistant"
                :before-remove="function(file, fileList) { child_beforeRemove(file, fileList, index); }"
                :data="{data_index:index,inp_name:item.name}"
                multiple>
                <img class="load_icon" src="../../assets/img/upload_icon.png" alt="">
                <div class="el-upload__text upload_text">
                    <div>{{$t('main.text88')}}</div>
                    <div><el-button class="upload_btn">{{$t('main.text89')}}</el-button></div>
                    <div v-if="item.url.length<=0">{{$t('main.text261')}}</div>
                    <div v-else>{{$t('main.text90')}}</div>
                </div>
            </el-upload>
          </el-form-item>
        </div>

          <el-form-item>
              <div class="add_btn" @click="add_upload_num">{{$t('main.text136')}}</div>
          </el-form-item>

          <el-form-item>
              <el-button class="Submit_btn" @click="upload_all_data">{{$t('main.text36')}}</el-button>
          </el-form-item>

        </el-form>
    </div>
  </div>
</template>

<script>
import {awsS3Auth,approve,getUserInfo} from '@/api/api';
import AWS from 'aws-sdk';

export default {
    data() {
        return {
            form:{},
            awsS3_data:'',
            aws_s3_loading:false,
            
            company_profile:[],//多个值 [url1,url2,url3]
            shareholder_info:[ //多个对象 [{name:name,url:url}]
                {name:"",url:[],uid:[]}
            ],
            index_u:null,

            show_child:true,
            fileList:[],
            child_arr:[],
            child_index_i:null,
            child_index_j:null,
            child_uid:[],
            old_index:'',
            old_index_arr:[],


            
        }
    },

    mounted() {
        this.S3Auth();
        setTimeout(() => {
            if(sessionStorage.getItem('token')==null){
                this.$router.push("/login");
            }
        }, 200);
    },
    methods:{
        // 随机数
        createCode() {
            var code = "";
            var codeLength = 10;
            var random = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9);
            for (var i = 0; i < codeLength; i++) {
                var index = Math.floor(Math.random() * 9);
                code += random[index];
            }
            return code;
        },
        add_upload_num(){
            if(this.shareholder_info.length>2){
                this.message.ismessage('error',this.$t('main.text221'));
                return false;
            }else{
                let obj={
                    name:'',
                    url:[],
                    uid:[]
                }
                this.shareholder_info.push(obj);
            }

        },
        async ossUpload(data){
            this.aws_s3_loading=true;
            let file_type = data.file.type.split("/")[1];
            const uploadPath =  'autonym/'+this.createCode()+'/'+this.random_16+'.'+file_type;
            let s3 = new AWS.S3();
            let params = {
                Body: data.file,
                Bucket: "data-storage-d3",
                Key: uploadPath,
                ACL: "public-read",
            };
            s3.putObject(params, (err) => {
            if (err) {
                console.log(err);
                console.log(err, err.stack);
                this.aws_s3_loading=false;
            } else {
                
                const url ="https://data-storage-d3.s3.ap-southeast-1.amazonaws.com/" +uploadPath;
                
                this.company_profile.push(url);
                this.aws_s3_loading=false;
                
                }
            });
        },
        async S3Auth() {
            const res = await awsS3Auth();
            if (res.data.code == 200) {
                this.awsS3_data = res.data.data;
                
                //参数
                AWS.config.update({
                region: "ap-southeast-1",
                credentials: new AWS.CognitoIdentityCredentials({
                    IdentityPoolId: this.awsS3_data.IdentityPoolId,
                    IdentityId: this.awsS3_data.IdentityId,
                    Logins: {
                    "cognito-identity.amazonaws.com": this.awsS3_data.Token,
                    },
                }),
                });
            }else{
                
                this.message.ismessage('error',res.data.msg);
            }
        },
        async ossUpload_assistant(data){
            this.aws_s3_loading=true;
            this.show_child=false;
            
            
            if(data.data.inp_name==''){
                
                this.message.ismessage('error',this.$t('main.text222'));
                this.aws_s3_loading=false;
                this.fileList=[];
                return false;
            }

            
            let file_type = data.file.type.split("/")[1];
            const uploadPath =  'autonym/'+this.createCode()+'/'+this.random_16+'.'+file_type;
            let s3 = new AWS.S3();
            let params = {
                Body: data.file,
                Bucket: "data-storage-d3",
                Key: uploadPath,
                ACL: "public-read",
            };
            s3.putObject(params, (err) => {
                if (err) {
                    console.error('error');
                    console.log(err);
                    console.log(err, err.stack);
                    alert(err, err.stack);
                    this.aws_s3_loading=false;
                } else {
                    
                    const url ="https://data-storage-d3.s3.ap-southeast-1.amazonaws.com/" +uploadPath;

                    
                    this.shareholder_info[data.data.data_index].name=data.data.inp_name;
                    this.shareholder_info[data.data.data_index].url.push(url)
                    this.shareholder_info[data.data.data_index].uid.push(data.file.uid)

                    
                    this.aws_s3_loading=false;
                    this.show_child=true;
                    
                }
            });

        },

        beforeRemove(file, fileList) {
            fileList;
            

            for (let i = 0; i < this.company_profile.length; i++) {
                if(this.company_profile[i].indexOf(file.name)!= -1){
                    this.index_u=i;
                    break
                }
            }
            this.company_profile.splice(this.index_u,1)

        },
        child_beforeRemove(file,fileList, index){
            fileList;
            
            for (let j = 0; j < this.shareholder_info[index].uid.length; j++) {
                if(this.shareholder_info[index].uid[j]==file.uid){
                    this.child_index_j=j;
                    break;
                }
            }
            
            

            this.shareholder_info[index].url.splice(this.child_index_j,1);
            this.shareholder_info[index].uid.splice(this.child_index_j,1);

        },

        upload_all_data(){
            
            // 判断 必须有一个主要 一个次要 （最多4个次要）
            if(this.company_profile.length<1){
                
                this.message.ismessage('error',this.$t('main.text223'));
                return false;
            }

            let checkCursor = false;
            const validItems = [];

            // 检索 做判断 只填名字 或者 1没有 2有 不发请求
            for (let i = 0; i < this.shareholder_info.length; i++) {
                if (this.shareholder_info[i].name && this.shareholder_info[i].url.length) {
                    validItems.push(this.shareholder_info[i]);
                    
                    checkCursor = true;
                    
                }
                if(
                    (this.shareholder_info[i].name && !this.shareholder_info[i].url.length) ||
                    (!this.shareholder_info[i].name && this.shareholder_info[i].url.length)
                ){
                    
                    this.message.ismessage('error',this.$t('main.text224'));
                    return false;
                }
            }

            if (!checkCursor) {
                
                this.message.ismessage('error',this.$t('main.text224'));
                return false;
            }

             approve({
                    company_profile:this.company_profile,
                    shareholder_info: validItems,
                }).then(res=>{
                    if (res.data.code==200) {
                        
                        this.message.ismessage('success',this.$t('main.text225'));
                        this.get_user_info();
                        
                    }else{
                        
                        this.message.ismessage('error',res.data.msg);
                    }
                })
                
        },
        get_user_info(){
            getUserInfo().then(res=>{
                if (res.data.code==200) {
                    localStorage.setItem('approve_status',res.data.data.approve_status);
                    if(res.data.data.approve_status==0||res.data.data.approve_status==3){
                        // this.$router.push("/upload");
                    }else{
                        this.$router.push("/");
                    }
                }
            })
        },

    }
}
</script>

<style scoped>
.upload_header{
    height: 104px;
    background: #041728;
    display: flex;
    position: relative;
}
.upload_t_logo{
    width: 230px;
    margin: auto;
}
.upload_t_btn{
  border: 1.5px solid #F1C787;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 8px 20px;
  cursor: pointer;
  margin-left: 10px;
  color: #F1C787;
  position: absolute;
  right: 30px;
  top: 50%;
  transform: translate(0,-50%);
}
.form_box{
    max-width: 420px;
    margin: auto;
}
.form_tit{
    font-weight: bold;
    font-size: 22px;
    line-height: 26px;
    color: #314869;
    margin-top: 60px;
}
.upload_box >>> .el-upload{
    width: 100%;
}
.upload_box >>> .el-upload-dragger{
    background: rgba(222, 185, 129, 0.04);
    border: 1.5px dashed #DEB981;
    border-radius: 4px;
    width: 100%;
    height: 190px;
}
.icon_upload{
    margin: 10px auto 0;
    font-size: 50px;
}
.upload_text div{
    line-height: initial;
    color: rgba(49, 72, 105, 0.6);
}
.upload_btn{
    background: linear-gradient(90deg, #F1C788 0.42%, #E3A84E 100.42%);
    border-color: #F1C788;
    box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
    border-radius: 4px;
    font-weight: bold;
    font-size: 15px;
    line-height: 18px;
    color: #fff;
    margin: 12px auto;
}
.box_top_tit{
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 18px;
    color: rgba(49, 72, 105, 0.8);
    margin-bottom: 12px;
}
.el-form-item {
    margin-bottom: 15px;
}
.add_btn{
    width: 214px;
    height: 46px;
    text-align: center;
    line-height: 46px;
    border-radius: 4px;
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    color: #191E29;
    border: 1px solid #00C18E;
    cursor: pointer;
    margin: 30px auto;
    /* box-shadow: 0px 2px 4px rgb(222 185 129 / 20%); */
}
.Submit_btn,
.Submit_btn:hover{
    background: linear-gradient(90deg, #F1C788 0.42%, #E3A84E 100.42%);
    box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
    border-radius: 4px;
    border-color: #F1C788;
    width: 100%;
    color: #fff;
    margin-bottom: 30px;
}
.load_icon{
    width: 30px;
    vertical-align: middle;
    margin-top: 25px;
    margin-bottom: 10px;
}
.upload_body >>> .el-upload-list__item .el-icon-close-tip{
    display: none !important;
    color: transparent;
}
</style>

<style scoped>
  /* 手机端 */
@media screen and (max-width: 850px) {
    .form_box{
        width: 80%;
        margin-top: 22px;
    }
    .upload_t_btn{
        margin-top: 90px;
    }




}
</style>